import React from "react";
import Chart from "react-apexcharts";

function chartPlatList(data) {
    const series =  [489, 
        700, 
        1386, 
        1694, 2046, 2232, 2514, 2556, 2958, 3019, 3806, 3841, 4011, 4037, 4653, 5137, 5666, 5728, 5863, 5935, 6588, 6825, 7446];
    // const label_status =["#A83D8E", "#482080", "#2269AE", "#ECC419", "#5F7C36", "#DD8524", "#1C3583" ,  '#4E6641',
    // '#BEBB56',
    // '#FFBC47',
    // '#AC3E1A',
    // '#6F0A12',
    // '#4D2221',
    // '#6A4531',
    // '#DA6B42',
    // '#8F4150',
    // '#DA6B42',
    // '#624489',
    // '#1A3164',
    // '#579E98',
    // '#ACA57B',
    // '#7F92AE' , "#FF0000"];
    var options = {
        chart: {
            width: "300",
            type: 'donut',
        },
        dataLabels: {
            enabled: data.fact , 
            style: {
                fontSize: '10px',
            },
            formatter(val, opts) {
                const value = opts.w.globals.initialSeries[opts.seriesIndex] ; 
                const name = opts.w.globals.labels[opts.seriesIndex];
                return [value , name]
            }
        },
        colors:["#A83D8E", "#482080", "#2269AE", "#ECC419", "#5F7C36", "#DD8524", "#1C3583", '#4E6641',
        '#BEBB56',
        '#FFBC47',
        '#AC3E1A',
        '#6F0A12',
        '#4D2221',
        '#6A4531',
        '#DA6B42',
        '#8F4150',
        '#DA6B42',
        '#624489',
        '#1A3164',
        '#579E98',
        '#ACA57B',
        '#7F92AE', "#FF0000"],
        fill: {
            colors:["#A83D8E", "#482080", "#2269AE", "#ECC419", "#5F7C36", "#DD8524", "#1C3583", '#4E6641',
            '#BEBB56',
            '#FFBC47',
            '#AC3E1A',
            '#6F0A12',
            '#4D2221',
            '#6A4531',
            '#DA6B42',
            '#8F4150',
            '#DA6B42',
            '#624489',
            '#1A3164',
            '#579E98',
            '#ACA57B',
            '#7F92AE', "#FF0000"],
        },
        labels: ['PBTV',
            'Nationwide',
            'Bangkok Jam 1',
            'Bangkok Jam 2',
            'In Mall',
            'Central Network',
            'Icon Siam',
            '6 CBD',
            'Motion Block 1',
            'Motion Block 2',
            'EMP-EMQ',
            'PI9',
            'Digital MRT',
            'The Prime 9',
            'PIDa MRT+Digital Wall Asoke',
            'The Base',
            'BigC',
            'The Panoramix',
            'Twin Tube+',
            'Eastin',
            'Show DC',
            'Twin Tube',
            'Victory Monument'],
        responsive: [{
            dataLabels: {
                enabled: true,
                enabledOnSeries: undefined,
                formatter(val, opts) {
                    const name = opts.w.globals.labels[opts.seriesIndex]
                    return [val.toFixed(1) + '%', name]
                }
            },
            // breakpoint: 800,
            options: {
                chart: {
                    width: "300"
                },
            }
        }],
        legend: {
            show: false,
            fontSize: '5px',
            position: 'bottom',
            horizontalAlign: 'center',
            markers: {
                width: 5,
                height: 5,
                strokeWidth: 0,
                strokeColor: '#fff',
                radius: 12,
                onClick: undefined,
                offsetX: 0,
                offsetY: 0
            },
        },
        stroke: {
            width: 0,
            colors: ["#fff"]
        },
        plotOptions: {
            pie: {
                customScale: 1,
                donut: {
                    labels: {
                        show: true,
                        total: {
                            show: true,
                            label: 'Jobs',
                            fontSize: '10x',
                            fontFamily: 'Montserrat, sans-serif',
                            fontWeight: 400,
                            color: '#41434A',
                            formatter: function (w) {
                                return w.globals.seriesTotals.reduce((a, b) => {
                                    return a + b
                                }, 0)
                            }
                        }
                    },

                },

            },
        },
    };




    return (

        <Chart options={options} series={series} type="donut" />

    )
}

export default chartPlatList














